<template>
  <a-modal v-model="modal" title="新建" width="1100px" :maskClosable="false" :closable="false">
    <div class="create-material" v-if="modal">
      <a-form-model :model="formData" ref="form" layout="inline" :rules="rules">
        <a-form-model-item
          label="生效时间"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="effectiveStartTime"
        >
          <a-date-picker v-model="formData.effectiveStartTime" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" size="small" />
        </a-form-model-item>
        <a-form-model-item
          label="失效时间"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="effectiveEndTime"
        >
          <a-date-picker v-model="formData.effectiveEndTime" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" size="small"/>
        </a-form-model-item>
      </a-form-model>
      <div>
        <ls-table-layout>
          <div class="table-page-search-wrapper" slot="search">
            <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
              <global-select
                slot="organizationCode"
                :value.sync="queryParams.organizationCode"
                selectType="selectAssemble"
                :selectData="inventOrg"
                :disabled="true"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :assembleLabel="true"
              />
              <global-select
                slot="workshopCode"
                :value.sync="queryParams.workshopCode"
                :selectData="workshopList"
                :disabled="true"
                selectType="selectFilter"
                :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
              />
            </ls-search-form>
          </div>
          <template v-slot:table>
            <div class="page-header-content">
              <ls-api-table
                ref="dataTable"
                :columns="columns"
                :tableProps="tableProps"
                :selectedRows.sync="selectedRows"
                :multi-select="true"
                @selectedRowChange="selectedRowChange"
                rowKey="id"
                :scroll="{ fixScreen: false, x: 400, y: 200 }"
              >
              </ls-api-table>
            </div>
          </template>
        </ls-table-layout>
      </div>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="submitLoading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import { mapState } from 'vuex'

import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'
import { apiTeamEmployeeUpdate } from '@/api/mes/productionPrepare/teamManage'

import { generateLsTableResData } from '@/utils/util.js'
import { apiEmployeeList } from '@/api/mes/productionPrepare/employee'
import { apiBomWorkshopFindList } from '@/api/mes/productionPrepare/attributeMaintenance'

export default {
  name: 'CreateEmployeeModal',
  mixins: [cacheSearch, cacheRequest],
  created() {
  },
  props: {
    selectRows: {
      type: [Array],
      default: undefined
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      workshopList: [], // 车间列表
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiEmployeeList, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        employeeName: undefined,
        employeeCode: undefined,
        organizationCode: undefined,
        workshopCode: undefined
      },
      formList: [
        { label: '组织', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '车间', decorator: ['workshopCode'], type: 'workshopCode' },
        { label: '姓名', decorator: ['employeeName'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '人员编码', decorator: ['employeeCode'], type: 'input', attrs: { placeholder: '请输入' } }],
      // 表格字段
      columns: [
        { title: '人员编码', dataIndex: 'employeeCode', align: 'center', width: 200 },
        { title: '姓名', dataIndex: 'employeeName', align: 'center', width: 140 }
      ],
      modal: false,
      formData: {
        teamCode: '',
        effectiveStartTime: '', //  生效时间
        effectiveEndTime: '', //  失效时间
        employeeCodeList: [] // 员工编码
      },
      loading: false,
      submitLoading: false,
      rules: {
        effectiveStartTime: [{ required: true, message: ' ', trigger: 'change' }],
        effectiveEndTime: [{ required: true, message: ' ', trigger: 'change' }]
      }
    }
  },
  methods: {
    // 初始化
    show () {
      this.$set(this.formData, 'teamCode', this.selectRows[0]?.teamCode || '')
      this.$set(this.formData, 'effectiveStartTime', '')
      this.$set(this.formData, 'effectiveEndTime', '')
      this.$set(this.queryParams, 'employeeName', '')
      this.$set(this.queryParams, 'employeeCode', '')
      this.$set(this.queryParams, 'organizationCode', this.selectRows[0]?.organizationCode || '')
      this.$set(this.queryParams, 'workshopCode', this.selectRows[0]?.workshopCode || '')
      this.modal = true
      this.$nextTick(() => {
        this.onSearch()
      })
      apiBomWorkshopFindList({
        workshopStatus: "Y",
        organizationCode: this.queryParams.organizationCode
      }).then(res => {
        if (res && res.length > 0) {
            this.workshopList = res
          } else {
            this.workshopList = []
          }
      });
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false
      this.currentId = ''
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationCode: this.selectRows[0]?.organizationCode || '',
        workshopCode: this.selectRows[0]?.workshopCode || '',
        employeeName: undefined,
        employeeCode: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 行选中
    selectedRowChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 确认创建
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          if (this.selectedRows.length < 1) {
            this.$message.warning('请选择人员')
            return;
          }

          this.formData.employeeCodeList = this.selectedRows.map(item => item.employeeCode);
          this.submitLoading = true;
          apiTeamEmployeeUpdate(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success('创建成功')
              this.$emit("refresh")
              this.modal = false
            } else {
              this.$message.error(res?.msg || '创建失败')
            }
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
